export default "__VITE_ASSET__3wpQ3Ilz__"